import { render, staticRenderFns } from "./modal-notification-add-cart.vue?vue&type=template&id=88e3dd0e&"
import script from "./modal-notification-add-cart.vue?vue&type=script&lang=js&"
export * from "./modal-notification-add-cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports